import { GridColDef, GridColumnVisibilityModel } from '@mui/x-data-grid';
import { fShortDate, getEndDate } from '@nps.today/component-library';
import DisabledIcon from 'components/util/Status/DisabledIcon';
import EnabledIcon from 'components/util/Status/EnabledIcon';
import { ITranslator } from 'translation/generated/translationInterface';

export const getBaseOrderColumns = (translator: ITranslator): GridColDef[] => [
  {
    field: 'id'
  },
  {
    field: 'description',
    headerName: translator.description(),
    flex: 1
  },
  {
    field: 'notes',
    headerName: translator.notes(),
    flex: 1
  },
  {
    field: 'active',
    headerName: translator.active(),
    type: 'boolean',
    flex: 1,
    renderCell: (params) => {
      const status = params.row.active as boolean;
      return status ? (
        <EnabledIcon tooltip={translator.active()} />
      ) : (
        <DisabledIcon tooltip={translator.inactive()} />
      );
    }
  },
  {
    field: 'renewable',
    headerName: translator.renewable(),
    type: 'boolean',
    flex: 1,
    renderCell: (params) => {
      const status = params.row.renewable as boolean;
      return status ? (
        <EnabledIcon tooltip={translator.renewable()} />
      ) : (
        <DisabledIcon tooltip={translator.notRenewable()} />
      );
    }
  },
  {
    field: 'startedat',
    headerName: translator.startDate(),
    flex: 1,
    renderCell: (params) => {
      const startDate = params.row.startedAt;
      try {
        const date = fShortDate(new Date(startDate));
        return date;
      } catch (error) {
        return translator.invalidDate(`${startDate}`, `${error}`);
      }
    }
  },
  {
    field: 'usageintervalmonths',
    headerName: translator.endDate(),
    flex: 1,
    renderCell: (params) => {
      if (!params.row.usageIntervalMonths) {
        return translator.noEndDate();
      }
      const startDate = new Date(params.row.startedAt);
      const usagePeriod = params.row.usageIntervalMonths as number;
      return getEndDate(startDate, usagePeriod);
    }
  },
  {
    field: 'paymentintervalmonths',
    headerName: translator.billingDate(),
    flex: 1,
    renderCell: (params) => {
      if (!params.row.usageIntervalMonths) {
        return translator.noBillingDate();
      }
      const startDate = new Date(params.row.startedAt);
      const paymentPeriod = params.row.paymentIntervalMonths as number;
      return getEndDate(startDate, paymentPeriod);
    }
  }
];

export const baseOrderInitialColumnsHidden: GridColumnVisibilityModel = {
  description: true,
  active: true,
  renewable: false,
  notes: false,
  startedat: false,
  usageintervalmonths: true,
  paymentintervalmonths: true
};
